import { render } from "./simpeg-dashboard.vue?vue&type=template&id=171147e8&scoped=true"
import script from "./simpeg-dashboard.vue?vue&type=script&lang=js"
export * from "./simpeg-dashboard.vue?vue&type=script&lang=js"

import "./simpeg-dashboard.vue?vue&type=style&index=0&id=171147e8&scoped=true&lang=css"
import "./simpeg-dashboard.vue?vue&type=style&index=1&id=171147e8&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171147e8"]])

export default __exports__